import { render, staticRenderFns } from "./template-grid.vue?vue&type=template&id=389cdcfe&scoped=true"
import script from "./template-grid.vue?vue&type=script&lang=js"
export * from "./template-grid.vue?vue&type=script&lang=js"
import style0 from "./template-grid.vue?vue&type=style&index=0&id=389cdcfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389cdcfe",
  null
  
)

export default component.exports